import React, {useRef, useEffect} from 'react';

import {StyledGrid} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {Loading} from '../Loading/Loading';
import {SentinelSentinelLoadingProps} from './types';

const {loading} = translations['pt-br'].commons;

export function SentinelLoading({
	onVisible,
	isLoading,
	minHeight,
	showLoadingText = true,
	sx,
}: SentinelSentinelLoadingProps) {
	const sentinelRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				if (entries[0].isIntersecting) {
					onVisible();
				}
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: 1.0,
			},
		);

		if (sentinelRef.current) {
			observer.observe(sentinelRef.current);
		}

		return () => {
			if (sentinelRef.current) {
				observer.unobserve(sentinelRef.current);
			}
		};
	}, [onVisible]);

	return (
		<StyledGrid.Item sm={12} md={12} lg={12} sx={sx}>
			<div ref={sentinelRef}>
				{isLoading ? (
					<Loading text={showLoadingText ? loading : undefined} minHeight={minHeight} />
				) : null}
			</div>
		</StyledGrid.Item>
	);
}
